export const MODULE_TYPE = "MODULE";
export const STACK_TYPE = "STACK";
